module.exports = require('./helpers/bundle-url').getBundleURL('lRwKX') + "logo-dark.eefe0b7f.svg";